import { useRouteMatch } from 'react-router-dom';
import * as NavMenu from 'components/nav-menu';

const TeamNavigation = () => {
    const match = useRouteMatch();
    return (
        <NavMenu.Root orientation="vertical" aria-label="Campaign team">
            <NavMenu.Item exact={true} to={`${match.url}`}>
                Individuals
            </NavMenu.Item>
            <NavMenu.Item to={`${match.url}/teams`}>Teams</NavMenu.Item>
            <NavMenu.Item to={`${match.url}/fundraise-settings`}>Settings</NavMenu.Item>
        </NavMenu.Root>
    );
};

export { TeamNavigation };
